import concert_Low_F from "./all_chromatic_scales/trumpet_chr_scale/concert_low_F.mp3";
import concert_Low_Gb from "./all_chromatic_scales/trumpet_chr_scale/concert_low_F_sharp.mp3";
import concert_Low_G from "./all_chromatic_scales/trumpet_chr_scale/concert_low_G.mp3";
import concert_Low_Ab from "./all_chromatic_scales/trumpet_chr_scale/concert_low_Ab.mp3";
import concert_Low_A from "./all_chromatic_scales/trumpet_chr_scale/concert_low_A.mp3";
import concert_Low_Bb from "./all_chromatic_scales/trumpet_chr_scale/concert_Low_Bb.mp3";
import concert_Low_B from "./all_chromatic_scales/trumpet_chr_scale/concert_low_B.mp3";
import concert_Low_C from "./all_chromatic_scales/trumpet_chr_scale/concert_low_C.mp3";
import concert_Low_Db from "./all_chromatic_scales/trumpet_chr_scale/concert_low_Db.mp3";
import concert_Low_D from "./all_chromatic_scales/trumpet_chr_scale/concert_low_D.mp3";
import concert_Low_Eb from "./all_chromatic_scales/trumpet_chr_scale/concert_low_Eb.mp3";
import concert_Low_E from "./all_chromatic_scales/trumpet_chr_scale/concert_low_E.mp3";
import concert_F from "./all_chromatic_scales/trumpet_chr_scale/concert_F.mp3";
import concert_Gb from "./all_chromatic_scales/trumpet_chr_scale/concert_Gb.mp3";
import concert_G from "./all_chromatic_scales/trumpet_chr_scale/concert_G.mp3";
import concert_Ab from "./all_chromatic_scales/trumpet_chr_scale/concert_Ab.mp3";
import concert_A from "./all_chromatic_scales/trumpet_chr_scale/concert_A.mp3";
import concert_Bb from "./all_chromatic_scales/trumpet_chr_scale/concert_Bb.mp3";
import concert_B from "./all_chromatic_scales/trumpet_chr_scale/concert_B.mp3";
import concert_C from "./all_chromatic_scales/trumpet_chr_scale/concert_C.mp3";
import concert_Db from "./all_chromatic_scales/trumpet_chr_scale/concert_Db.mp3";
import concert_D from "./all_chromatic_scales/trumpet_chr_scale/concert_D.mp3";
import concert_Eb from "./all_chromatic_scales/trumpet_chr_scale/concert_Eb.mp3";
import concert_E from "./all_chromatic_scales/trumpet_chr_scale/concert_E.mp3";
import concert_High_F from "./all_chromatic_scales/trumpet_chr_scale/concert_High_F.mp3";
import concert_High_Gb from "./all_chromatic_scales/trumpet_chr_scale/concert_High_Gb.mp3";
import concert_High_G from "./all_chromatic_scales/trumpet_chr_scale/concert_High_G.mp3";
import concert_High_Ab from "./all_chromatic_scales/trumpet_chr_scale/concert_High_Ab.mp3";
import concert_High_A from "./all_chromatic_scales/trumpet_chr_scale/concert_High_A.mp3";
import concert_High_Bb from "./all_chromatic_scales/trumpet_chr_scale/concert_High_Bb.mp3";
import concert_High_B from "./all_chromatic_scales/trumpet_chr_scale/concert_High_B.mp3";

//images
import Low_G from "../app/images/treble-clef-notes/Low-G.png";
import Low_Ab from "../app/images/treble-clef-notes/Low-Ab.png";
import Low_A from "../app/images/treble-clef-notes/Low-A.png";
import Low_Bb from "../app/images/treble-clef-notes/Low-Bb.png";
import Low_B from "../app/images/treble-clef-notes/Low-B.png";
import Low_C from "../app/images/treble-clef-notes/Low-C.png";
import Low_Csharp from "../app/images/treble-clef-notes/Low-Csharp.png";
import Low_D from "../app/images/treble-clef-notes/Low-D.png";
import Low_Eb from "../app/images/treble-clef-notes/Low-Eb.png";
import Low_E from "../app/images/treble-clef-notes/Low-E.png";
import Low_F from "../app/images/treble-clef-notes/Low-F.png";
import Low_Fsharp from "../app/images/treble-clef-notes/Low-Fsharp.png";
import Middle_G from "../app/images/treble-clef-notes/Middle-G.png";
import Middle_Gsharp from "../app/images/treble-clef-notes/Middle-Gsharp.png";
import Middle_A from "../app/images/treble-clef-notes/Middle-A.png";
import Middle_Bb from "../app/images/treble-clef-notes/Middle-Bb.png";
import Middle_B from "../app/images/treble-clef-notes/Middle-B.png";
import Middle_C from "../app/images/treble-clef-notes/Middle-C.png";
import Middle_Csharp from "../app/images/treble-clef-notes/Middle-Csharp.png";
import Middle_D from "../app/images/treble-clef-notes/Middle-D.png";
import Middle_Eb from "../app/images/treble-clef-notes/Middle-Eb.png";
import Middle_E from "../app/images/treble-clef-notes/Middle-E.png";
import Middle_F from "../app/images/treble-clef-notes/Middle-F.png";
import Middle_Fsharp from "../app/images/treble-clef-notes/Middle-Fsharp.png";
import High_G from "../app/images/treble-clef-notes/High-G.png";
import High_Ab from "../app/images/treble-clef-notes/High-Ab.png";
import High_A from "../app/images/treble-clef-notes/High-A.png";
import High_Bb from "../app/images/treble-clef-notes/High-Bb.png";
import High_B from "../app/images/treble-clef-notes/High-B.png";
import High_C from "../app/images/treble-clef-notes/High-C.png";
import High_Csharp from "../app/images/treble-clef-notes/High-Csharp.png";

export const trumpetChrScale = [
  {
    image: Low_G,
    index: 0,
    name: "Low G",
    audio_file: new Audio(concert_Low_F),
  },
  {
    index: 1,
    name: "Low Ab",
    image: Low_Ab,
    audio_file: new Audio(concert_Low_Gb),
  },
  {
    index: 2,
    name: "Low A",
    image: Low_A,
    audio_file: new Audio(concert_Low_G),
  },
  {
    index: 3,
    name: "Low Bb",
    image: Low_Bb,
    audio_file: new Audio(concert_Low_Ab),
  },
  {
    index: 4,
    name: "Low B",
    image: Low_B,
    audio_file: new Audio(concert_Low_A),
  },
  {
    index: 5,
    image: Low_C,
    name: "Low C",
    audio_file: new Audio(concert_Low_Bb),
  },
  {
    index: 6,
    name: "Low C#",
    image: Low_Csharp,
    audio_file: new Audio(concert_Low_B),
  },
  {
    index: 7,
    name: "Low D",
    image: Low_D,
    audio_file: new Audio(concert_Low_C),
  },
  {
    index: 8,
    name: "Low Eb",
    image: Low_Eb,
    audio_file: new Audio(concert_Low_Db),
  },
  {
    index: 9,
    name: "Low E",
    image: Low_E,
    audio_file: new Audio(concert_Low_D),
  },
  {
    index: 10,
    name: "Low F",
    image: Low_F,
    audio_file: new Audio(concert_Low_Eb),
  },
  {
    index: 11,
    name: "Low F#",
    image: Low_Fsharp,
    audio_file: new Audio(concert_Low_E),
  },
  {
    index: 12,
    name: "Middle G",
    image: Middle_G,
    audio_file: new Audio(concert_F),
  },
  {
    index: 13,
    name: "Middle G#",
    image: Middle_Gsharp,
    audio_file: new Audio(concert_Gb),
  },
  {
    index: 14,
    name: "Middle A",
    image: Middle_A,
    audio_file: new Audio(concert_G),
  },
  {
    index: 15,
    name: "Middle Bb",
    image: Middle_Bb,
    audio_file: new Audio(concert_Ab),
  },
  {
    index: 16,
    name: "Middle B",
    image: Middle_B,
    audio_file: new Audio(concert_A),
  },
  {
    index: 17,
    name: "Middle C",
    image: Middle_C,
    audio_file: new Audio(concert_Bb),
  },
  {
    index: 18,
    name: "Middle C#",
    image: Middle_Csharp,
    audio_file: new Audio(concert_B),
  },
  {
    index: 19,
    name: "Middle D",
    image: Middle_D,
    audio_file: new Audio(concert_C),
  },
  {
    index: 20,
    name: "Middle Eb",
    image: Middle_Eb,
    audio_file: new Audio(concert_Db),
  },
  {
    index: 21,
    name: "Middle E",
    image: Middle_E,
    audio_file: new Audio(concert_D),
  },
  {
    index: 22,
    name: "Middle F",
    image: Middle_F,
    audio_file: new Audio(concert_Eb),
  },
  {
    index: 23,
    name: "Middle F#",
    image: Middle_Fsharp,
    audio_file: new Audio(concert_E),
  },
  {
    index: 24,
    name: "High G",
    image: High_G,
    audio_file: new Audio(concert_High_F),
  },
  {
    index: 25,
    name: "High Ab",
    image: High_Ab,
    audio_file: new Audio(concert_High_Gb),
  },
  {
    index: 26,
    name: "High A",
    image: High_A,
    audio_file: new Audio(concert_High_G),
  },
  {
    index: 27,
    name: "High Bb",
    image: High_Bb,
    audio_file: new Audio(concert_High_Ab),
  },
  {
    index: 28,
    name: "High B",
    image: High_B,
    audio_file: new Audio(concert_High_A),
  },
  {
    index: 29,
    name: "High C",
    image: High_C,
    audio_file: new Audio(concert_High_Bb),
  },
  {
    index: 30,
    name: "High C#",
    image: High_Csharp,
    audio_file: new Audio(concert_High_B),
  },
];
